export const FORGOT_PASSWORD_PATH = "/forgot-password";
